<template>
  <nav
    class="navbar navbar-expand-md navbar-dark bg-primary fixed-left"
    :style="{background: bgcolor + ' !important'}"
  >
    <router-link :to="{ name: 'dashboard' }" class="navbar-brand">
      <div class="logo"></div>
    </router-link>

    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbars"
      aria-controls="navbars"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" :style="{color: txtcolor + ' !important'}"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbars">
      <div class="bar_user text-center">
        <router-link :to="'/usuarios/password'" class="txt_user">{{user_name}}</router-link>
      </div>

      <ul class="navbar-nav">
        <li v-for="rota in rotas" :key="rota.path" class="nav-item hvr-grow">
          <router-link
            :to="rota.path ? rota.path : '/'"
            class="nav-link"
            :style="{color: txtcolor}"
          >
            <i :class="rota.icon"></i>
            {{ rota.title }}
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      user_name: localStorage.getItem("name")
    };
  },
  props: {
    rotas: {
      type: Array,
      required: true
    },
    bgcolor: {
      type: String
    },
    txtcolor: {
      type: String
    }
  },

  methods: {
    redirect(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style>
a {
  cursor: pointer;
}
/* body {
  padding-top: 90px; 
} */

@media only screen and (max-width: 768px) {
  .logo {
    width: 30px !important;
    height: 30px !important;
    background-image: url("/static/icon.png") !important;
  }
}
@media (min-width: 768px) {
  .bar_user {
    border-top: 1px solid #fff;
    /* border-right:  2px dashed #fff; */
    border-bottom: 1px solid #fff;
    /* border-left:   5px solid  #fff; */
    vertical-align: middle;
    background: rgba(255, 255, 255, 0.2);
    /* margin-left: 50px; */
    min-width: 231px;
    width: 100% !important;
    height: 25px;
  }

  .txt_user {
    margin: 0;
    padding: 0;
    text-decoration: none !important;
    font-weight: bold;
    color: rgb(252, 221, 14) !important;
  }

  .logo {
    width: 170px !important;
    height: 54px !important;
    background-image: url("/static/logo_brasil_branco.png") !important;
  }
  body {
    padding-top: 0;
  }
}
@media (min-width: 768px) {
  body {
    margin-left: 232px;
  }
}
li {
  opacity: 0.8;
  border-bottom: 1px solid white;
}
li:hover {
  opacity: 1;
}
.router-link-active {
  color: white !important;
}
.logo {
  margin: 0;
  padding: 0;
  background-size: 70%;
  background-position: center;
  background-repeat: no-repeat;
}
.navbar-brand {
  width: 100%;
  /* Firefox */
  display: -moz-box;
  -moz-box-pack: center;
  -moz-box-align: center;
  /* Safari and Chrome */
  display: -webkit-box;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  /* W3C */
  display: box;
  box-pack: center;
  box-align: center;
}
.navbar.fixed-left {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
}
@media (min-width: 768px) {
  .navbar.fixed-left {
    bottom: 0;
    width: 232px;
    flex-flow: column nowrap;
    align-items: flex-start;
  }
  .navbar.fixed-left .navbar-collapse {
    flex-grow: 0;
    flex-direction: column;
    width: 100%;
  }
  .navbar.fixed-left .navbar-collapse .navbar-nav {
    flex-direction: column;
    width: 100%;
  }
  .navbar.fixed-left .navbar-collapse .navbar-nav .nav-item {
    width: 100%;
  }
  .navbar.fixed-left .navbar-collapse .navbar-nav .nav-item .dropdown-menu {
    top: 0;
  }
}
@media (min-width: 768px) {
  .navbar.fixed-left {
    right: auto;
  }
  .navbar.fixed-left .navbar-nav .nav-item .dropdown-toggle:after {
    border-top: 0.3em solid transparent;
    border-left: 0.3em solid;
    border-bottom: 0.3em solid transparent;
    border-right: none;
    vertical-align: baseline;
  }
  .navbar.fixed-left .navbar-nav .nav-item .dropdown-menu {
    left: 100%;
  }
}
.navbar {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  border-radius: 2px;
  padding: 20px;
  padding-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/side-menu/SideMenu.vue